import {Card, Col, Image, Modal, Row, Tabs} from "antd";
import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import dummy from "../../../../assets/image/dummy_obj.png";

const PlatformDownloadModal = (props) => {
    const {isModalOpen, handleCancel, platformData} = props;
    const {t} = useTranslation();

    const language = localStorage.getItem("language");

    const items = useMemo(() => {
        return Object.keys(platformData)?.map((key, index) => ({
            key: index + 1,
            label: t(key),
            children: (
                <Row gutter={[16, 16]}>
                    {Object.keys(platformData[key])?.map((item, i) => {
                        if (
                            item !== "server" &&
                            item !== "__typename" &&
                            key &&
                            platformData[key] &&
                            item &&
                            platformData[key].hasOwnProperty(item) &&
                            platformData[key][item]?.isEnabled
                        ) {
                            const data = platformData[key][item];
                            const platformDisplayName =
                                data?.displayNameLanguage?.find((v) => v?.language === language)?.label ??
                                data?.displayNameLanguage?.find((v) => v?.language === "en")?.label ??
                                data?.displayName;

                            return (
                                <Col xs={24} md={12} lg={8} className={"mb-2"} key={i}>
                                    <a className={"text-decoration-none h-full"} href={data?.link} target={"_blank"}>
                                        <Card className={"platformDownloadCard h-full"}>
                                            <Col span={24} className={"text-center"}>
                                                <Image
                                                    width={115}
                                                    height={115}
                                                    src={data?.icon ? data?.icon : data?.defaultIcon ? data?.defaultIcon : dummy}
                                                    style={{objectFit: "cover"}}
                                                    preview={false}
                                                />
                                                <p className={"mt-6"}>{platformDisplayName}</p>
                                            </Col>
                                        </Card>
                                    </a>
                                </Col>
                            );
                        }
                    })}
                </Row>
            )
        }));
    }, [platformData]);

    return (
        <Modal
            title={t("module.platformDownload")}
            className={"platformDownloadModal"}
            open={isModalOpen}
            footer={null}
            onCancel={handleCancel}
            width={"60%"}
            getContainer={() => document.getElementById("layout-5")}
        >
            <Tabs items={items}/>
        </Modal>
    );
};

export default PlatformDownloadModal;
